<template>
  <div>
    <Head title="Regjionet" />
    <h1 class="mb-8 text-3xl font-bold">Regjionet e shoferëve mbledhës</h1>

    <danger-flash-message message="Kujdes, çdo konfigurim rrezikon të afektoj të dhënat e tjera!"></danger-flash-message>

    <div class="flex items-center justify-between mb-6">
      <Link class="btn-indigo" href="regjionet/krijo">
        <span>Regjistro</span>
        <span class="hidden md:inline"> Regjion të ri</span>
      </Link>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <thead>
        <tr class="text-left font-bold">
          <th class="pb-4 pt-6 px-6">Emri</th>
          <th class="pb-4 pt-6 px-6">Qytetet/Lagjet</th>
          <th class="pb-4 pt-6 px-6">Shoferi</th>
          <th class="pb-4 pt-6 px-6">Krijuar më</th>
          <th class="pb-4 pt-6 px-6" colspan="2">Edituar më</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="region in regions.data" :key="region.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`regjionet/${region.id}/edit`">
              {{ region.name }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4" :href="`regjionet/${region.id}/edit`" tabindex="-1">
              <span class="mx-0.5 px-2 py-1 bg-indigo-100 rounded-md" v-for="town in region.towns">{{town}}</span>
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4" :href="`regjionet/${region.id}/edit`" tabindex="-1">
              {{ region.driver_first_name }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4" :href="`regjionet/${region.id}/edit`" tabindex="-1">
              {{ region.hr_created_at }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4" :href="`regjionet/${region.id}/edit`" tabindex="-1">
              {{ region.hr_updated_at }}
            </Link>
          </td>
          <td class="w-px border-t">
            <Link class="flex items-center px-4" :href="`regjionet/${region.id}/edit`" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </Link>
          </td>
        </tr>
        <tr v-if="regions.data.length === 0">
          <td class="px-6 py-4 border-t" colspan="4">Nuk u gjet asnjë regjion.</td>
        </tr>
        </tbody>
      </table>
    </div>
        <pagination class="mt-6" :links="regions.meta.links" />
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'
import DangerFlashMessage from '@/Shared/DangerFlashMessage'

export default {
  components: {
    DangerFlashMessage,
    Head,
    Icon,
    Link,
    Pagination,
  },
  layout: Layout,
  props: {
    regions: Object,
  },
  data() {
    return {
      form: {
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/admin/konfigurimet/regjionet', pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
